import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo:{governmentId:'', firstName:'', lastName:'', location:{}, enteredDate:''},
        survey:{},
        dependentQuestions:{},
        questionaire:{questionIdsList:[], showImportantQuestionMessage:false,
            importantQuestions:{multipleChoice:{}}, originalImpQuestion:{}},
        showHideStreet:{}

    },
    getters:{
        userInfo: state => {
            return state.userInfo;
        },
        _questionaire: state => {
            return state.questionaire;
        },
        questionIds: state => {
            return state.questionIdsList;
        },
        showHideStreet: state => {
            return state.showHideStreet;
        }

    },
    mutations: {
        saveUserInfo(state, userInfo) {
            //state.userInfo = userInfo;
            Object.keys(userInfo).forEach(val => {
                state.userInfo[val] = userInfo[val];
            })
        },
        resetDependency(state, deps){
            if(!deps){
                return
            }
            state.dependentQuestions = {};
            state.dependentQuestions = deps;
        },
        resetSurvey(state){
            // state.survey = {};
            let surveyKeys = Object.keys(state.survey);
            for (let key of surveyKeys){
                delete state.survey[key]
            }
            let keys = Object.keys(state.showHideStreet);
            if(keys){
                for(let v of keys){
                    if(v.includes("vuePreviewSurveyDataframe_street_")){
                        state.showHideStreet = {};
                        state.showHideStreet[v] = false;
                    }
                }
            }

        },
        insertToQuestionaire(state, obj){
            if(!obj){
                return
            }
            let qTemp = state.questionaire;
            qTemp[obj.key] = obj.value;
            // state.questionaire = {};
            state.questionaire = qTemp;
        },
        showHideStreet(state, obj){
            if(!obj){
                return
            }
            let qTemp = state.showHideStreet;
            qTemp[obj.key] = obj.value;
            state.showHideStreet = {};
            state.showHideStreet = qTemp;
        }
    },

    actions: {

    }
})
